import React from 'react';
import { ExternalLink, Download } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { isDownloadPortal, SOURCE_LINK_TOOLTIP } from '@/utils/procurementSourceUtils';

/**
 * Source link for procurement deals. Opens in new tab.
 * Phase 1: Tooltip explaining downloads. Phase 2: Download icon for known portals.
 */
export default function SourceLink({
  url,
  variant = 'icon',
  className = '',
  onClick,
}) {
  if (!url) return null;
  const isDownload = isDownloadPortal(url);

  const linkContent =
    variant === 'icon' ? (
      isDownload ? (
        <Download className="w-4 h-4 text-[#00C2C2]" />
      ) : (
        <ExternalLink className="w-4 h-4 text-[#00C2C2]" />
      )
    ) : (
      <span className="inline-flex items-center gap-2">
        {isDownload ? (
          <Download className="w-4 h-4" />
        ) : (
          <ExternalLink className="w-4 h-4" />
        )}
        {isDownload ? 'Source document' : 'Open source'}
      </span>
    );

  const tooltipText = isDownload
    ? `${SOURCE_LINK_TOOLTIP} This portal often triggers a download.`
    : SOURCE_LINK_TOOLTIP;

  const link = (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={
        variant === 'icon'
          ? `p-1 rounded hover:bg-gray-100 ${className}`
          : `inline-flex items-center gap-2 text-sm text-[#00C2C2] hover:text-[#00A3A3] ${className}`
      }
      onClick={onClick}
    >
      {linkContent}
    </a>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>{link}</TooltipTrigger>
      <TooltipContent side="top" className="max-w-[240px]">
        {tooltipText}
      </TooltipContent>
    </Tooltip>
  );
}
